<header
  class="header"
  [class.scrolled]="isScrolled"
  [class.dark-bg]="isDarkBackground"
  [class.light-bg]="!isDarkBackground"
  [class.mobile-menu-open]="isMobileMenuOpen"
>
  <div class="header--container">
    <!-- Logo -->
    <div class="header--logo">
      <a routerLink="/" class="logo--link">
        <img
          [src]="isDarkBackground ? '/logo.svg' : '/iudx-health-logo.svg'"
          alt="IUDX Health"
          class="logo--image"
        />
      </a>
    </div>

    <div class="header--right-cluster">
      <!-- Navigation Menu -->
      <nav class="header--nav">
        <ul class="nav--menu">
          <li class="nav--item">
            <a routerLink="/about-us" 
               class="nav--link" 
               [class.nav--link-active]="isAboutPageActive()"
               (click)="closeMobileMenu()"
              >About us</a
            >
          </li>
          <li class="nav--item">
            <a routerLink="/datasets" 
               class="nav--link" 
               [class.nav--link-active]="isDatasetsPageActive()"
               (click)="closeMobileMenu()"
              >Datasets</a
            >
          </li>
          <li class="nav--item">
            <a routerLink="/models" 
               class="nav--link" 
               [class.nav--link-active]="isModelsPageActive()"
               (click)="closeMobileMenu()"
              >Models</a
            >
          </li>
          <li class="nav--item">
            <a routerLink="/usecases" 
               class="nav--link" 
               [class.nav--link-active]="isUsecasesPageActive()"
               (click)="closeMobileMenu()"
              >Usecases</a
            >
          </li>
          <li class="nav--item">
            <a routerLink="/sandbox" 
               class="nav--link" 
               [class.nav--link-active]="isSandboxPageActive()"
               (click)="closeMobileMenu()"
              >Sandbox</a
            >
          </li>
          <li class="nav--item">
            <a routerLink="/leaderboard" 
               class="nav--link"
               [class.nav--link-active]="isLeaderboardPageActive()"
               (click)="closeMobileMenu()"
              >Leaderboard</a
            >
          </li>
          <li class="nav--item">
            <a routerLink="/challenges" 
               class="nav--link" 
               [class.nav--link-active]="isChallengesPageActive()"
               (click)="closeMobileMenu()"
              >Challenges</a
            >
          </li>
          <li class="nav--item others--dropdown-container">
            <button
              type="button"
              class="nav--link others--dropdown-trigger"
              [class.nav--link-active]="isOthersMenuOpen || isOthersPageActive()"
              [attr.aria-expanded]="isOthersMenuOpen"
              (click)="toggleOthersMenu($event)"
            >
              Resources
            </button>
            <div class="others--dropdown-menu" *ngIf="isOthersMenuOpen" (click)="$event.stopPropagation()">
              <div class="others-menu--grid">
                <button
                  *ngFor="let item of othersMenuItems"
                  type="button"
                  class="others-menu--item"
                  [class.others-menu--item-disabled]="item.comingSoon"
                  (click)="onOthersMenuItemClick(item)"
                >
                  <span class="others-menu--item-heading">
                    <span class="others-menu--item-icon">
                      <svg *ngIf="item.icon === 'toolset'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                      </svg>
                      <svg *ngIf="item.icon === 'privacy'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                      </svg>
                      <svg *ngIf="item.icon === 'terms'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
                      </svg>
                      <svg *ngIf="item.icon === 'contact'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                      </svg>
                    </span>
                    <span class="others-menu--item-title">{{ item.title }}<span *ngIf="item.comingSoon" class="others-menu--badge">Soon</span></span>
                  </span>
                  <span class="others-menu--item-desc">{{ item.description }}</span>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </nav>

      <!-- Action Buttons -->
      <div class="header--actions">
      <!-- Show Login/Register buttons when NOT logged in -->
      <ng-container *ngIf="!isLoggedIn">
        <button class="btn--login" (click)="onLogin()" type="button">Login</button>
        <button class="btn--register" (click)="onRegister()">Register</button>
      </ng-container>

      <!-- Show User dropdown when logged in -->
      <ng-container *ngIf="isLoggedIn">
        <div class="user--dropdown-container">
          <button 
            class="user--dropdown-trigger" 
            (click)="toggleUserDropdown($event)"
            [class.active]="isUserDropdownOpen"
          >
            <span class="user--avatar">{{ userInitials }}</span>
          </button>

          <!-- Dropdown Menu -->
          <div class="user--dropdown-menu" *ngIf="isUserDropdownOpen" (click)="$event.stopPropagation()">
            <ul class="dropdown--list">
              <li class="dropdown--item" *ngIf="!isAdmin">
                <button 
                  class="dropdown--link" 
                  [class.disabled]="isUpgradeDisabled"
                  [disabled]="isUpgradeDisabled"
                  (click)="onUpgradeRoleClick($event)">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Upgrade Your Role
                </button>
              </li>
              <li class="dropdown--item">
                <button class="dropdown--link" (click)="navigateToDashboard(); closeUserDropdown()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Dashboard
                </button>
              </li>
              <li class="dropdown--item">
                <button class="dropdown--link" (click)="navigateToProfile()">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Profile
                </button>
              </li>
            </ul>
            <div class="dropdown--divider"></div>
            <button class="dropdown--logout" (click)="onLogout()">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9M16 17L21 12M21 12L16 7M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Sign Out
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Hamburger Menu Button (Mobile Only) -->
      <button
        class="btn--hamburger"
        (click)="toggleMobileMenu()"
        aria-label="Toggle menu"
      >
        <span class="hamburger--icon">
          <span class="hamburger--line"></span>
          <span class="hamburger--line"></span>
          <span class="hamburger--line"></span>
        </span>
      </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu Overlay -->
  <div
    class="mobile-menu--overlay"
    (click)="closeMobileMenu()"
    *ngIf="isMobileMenuOpen"
  ></div>

  <!-- Mobile Menu -->
  <nav class="mobile-menu" [class.open]="isMobileMenuOpen">
    <ul class="mobile-menu--list">
      <li class="mobile-menu--item">
        <a routerLink="/about-us" 
           class="mobile-menu--link" 
           [class.mobile-menu--link-active]="isAboutPageActive()"
           (click)="closeMobileMenu()"
          >About us</a
        >
      </li>
      <li class="mobile-menu--item">
        <a routerLink="/datasets" 
           class="mobile-menu--link" 
           [class.mobile-menu--link-active]="isDatasetsPageActive()"
           (click)="closeMobileMenu()"
          >Datasets</a
        >
      </li>
      <li class="mobile-menu--item">
        <a routerLink="/models" 
           class="mobile-menu--link" 
           [class.mobile-menu--link-active]="isModelsPageActive()"
           (click)="closeMobileMenu()"
          >Models</a
        >
      </li>
      <li class="mobile-menu--item">
        <a routerLink="/usecases" 
           class="mobile-menu--link" 
           [class.mobile-menu--link-active]="isUsecasesPageActive()"
           (click)="closeMobileMenu()"
          >Usecases</a
        >
      </li>
      <li class="mobile-menu--item">
        <a routerLink="/sandbox" 
           class="mobile-menu--link" 
           [class.mobile-menu--link-active]="isSandboxPageActive()"
           (click)="closeMobileMenu()"
          >Sandbox</a
        >
      </li>
      <li class="mobile-menu--item">
        <a routerLink="/leaderboard" 
           class="mobile-menu--link"
           [class.mobile-menu--link-active]="isLeaderboardPageActive()"
           (click)="closeMobileMenu()"
          >Leaderboard</a
        >
      </li>
      <li class="mobile-menu--item">
        <a
          routerLink="/challenges"
          class="mobile-menu--link"
          [class.mobile-menu--link-active]="isChallengesPageActive()"
          (click)="closeMobileMenu()"
          >Challenges</a
        >
      </li>
      <li class="mobile-menu--item" *ngFor="let item of othersMenuItems">
        <a
          *ngIf="item.route"
          [routerLink]="item.route"
          class="mobile-menu--link"
          (click)="closeMobileMenu()"
          >{{ item.title }}</a
        >
        <span *ngIf="!item.route" class="mobile-menu--link mobile-menu--link-disabled">{{ item.title }} (Coming soon)</span>
      </li>
      <li class="mobile-menu--item mobile-menu--actions">
        <!-- Show Login/Register in mobile when NOT logged in -->
        <ng-container *ngIf="!isLoggedIn">
          <button class="btn--login-mobile" (click)="onLogin(); closeMobileMenu()">Login</button>
          <button class="btn--register-mobile" (click)="onRegister(); closeMobileMenu()">Register</button>
        </ng-container>

        <!-- Show Logout in mobile when logged in -->
        <ng-container *ngIf="isLoggedIn">
          <div class="user--name-mobile">{{ userName }}</div>
          <button class="btn--logout-mobile" (click)="onLogout(); closeMobileMenu()">Logout</button>
        </ng-container>
      </li>
    </ul>
  </nav>
  
  <!-- Upgrade Role Modal -->
  <app-modal
    [(visible)]="isUpgradeModalVisible"
    header="Upgrade Your Role"
    [width]="'1000px'"
    [showFooter]="false"
  >
    <div class="upgrade-modal-content" style="overflow: visible;">
      <!-- Intro Text -->
      <p class="roles-intro-text">
        Choose a role that aligns with how you want to use IUDX Health.
        Each role unlocks specific capabilities—whether you want to explore,
        publish assets on the platform or run AI experiments.
      </p>

      <!-- Roles Grid -->
      <div class="roles-grid">
        <div 
          *ngFor="let role of roles" 
          class="role-card"
        >
          <div class="role-card-header">
            <div class="role-icon-container">
              <svg class="role-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path [attr.d]="role.icon" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="role-title-container">
              <h3 class="role-card-title">{{ role.title }}</h3>
              <span 
                class="role-pending-badge" 
                *ngIf="(role.id === 'provider' && hasPendingProviderRole) || (role.id === 'compute' && hasPendingComputeRole)"
              >
                Request Pending
              </span>
              <span 
                class="role-granted-checkmark" 
                *ngIf="(role.id === 'provider' && hasProviderRole) || (role.id === 'compute' && hasComputeRole)"
                title="Granted"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="checkmark-icon">
                  <path d="M20 6L9 17l-5-5"/>
                </svg>
              </span>
            </div>
          </div>
          
          <p class="role-card-description">{{ role.description }}</p>
          
          <!-- Pending Organisation Note - Only for Data Publisher when status is pending -->
          <div class="role-organisation-note role-organisation-note--pending" *ngIf="role.id === 'provider' && showPendingOrganisationNote">
            <svg class="organisation-note-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
            <span class="organisation-note-text">Your request has been sent waiting for <span class="organisation-note-text--approval">approval</span></span>
          </div>
          
          <!-- Granted Organisation Note - Only for Data Publisher when status is granted -->
          <div class="role-organisation-note role-organisation-note--granted" *ngIf="role.id === 'provider' && showGrantedOrganisationNote">
            <svg class="organisation-note-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
            </svg>
            <span class="organisation-note-text">Your organisation has been approved</span>
          </div>
          
          <!-- Organisation Requirement Note - Only for Data Publisher when user doesn't have organisation -->
          <div class="role-organisation-note" *ngIf="role.id === 'provider' && showOrganisationNote">
            <svg class="organisation-note-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
            </svg>
            <span class="organisation-note-text">You need to be part of an Organisation</span>
          </div>
          
          <div class="role-features">
            <div class="feature-item" *ngFor="let feature of role.features">
              <svg class="feature-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
              </svg>
              <span>{{ feature }}</span>
            </div>
          </div>
          
          <!-- Request Upgrade Button for other states -->
          <button 
            *ngIf="(role.id !== 'compute' || !hasComputeRole) && !isRoleRequestSent[role.id]"
            class="btn-request-upgrade"
            [class.role-granted]="(role.id === 'provider' && hasProviderRole)"
            [disabled]="isRoleButtonDisabled(role.id)"
            (click)="handleRoleSelection(role.id)"
          >
            {{ getRoleButtonText(role.id) }}
          </button>
        </div>
      </div>
    </div>
  </app-modal>
</header>
